import types from '../types'

const minusPassenger = (passengerType) => ({
  type: types.PASSENGER_MINUS,
  payload: passengerType,
})

const addPassenger = (passenger) => ({
  type: types.PASSENGER_ADD,
  payload: passenger,
})

const removeExactPassenger = (id) => ({
  type: types.PASSENGER_REMOVE,
  payload: id,
})

const updatePassenger = (passengerId, passenger) => ({
  type: types.PASSENGER_UPDATE,
  payload: { passengerId, passenger },
})

const updatePax = (pax) => ({
  type: types.PAX_UPDATE,
  payload: pax,
})

const passengerDetailsReceived = () => ({
  type: types.PASSENGER_OPTIONS_RETRIEVED,
})

export default {
  minusPassenger,
  addPassenger,
  removeExactPassenger,
  updatePassenger,
  updatePax,
  passengerDetailsReceived,
}
